import React from 'react';

import MuiMenuItem, { MenuItemProps } from 'ha/ui/next/MenuItem';
import Link from 'ha/ui/next/Link';

interface Props {
  rel?: string;
  to?: string;
  children: React.ReactNode;
}

export default React.forwardRef<HTMLLIElement, Props & MenuItemProps>(
  function MenuItem({ to, ...rest }) {
    const componentProps = to
      ? { to, component: Link, kind: 'dark-blue', disableOutline: true }
      : undefined;

    return <MuiMenuItem {...rest} button {...componentProps} />;
  },
);
